import { render, staticRenderFns } from "./LeadToActive.vue?vue&type=template&id=ede961aa"
import script from "./LeadToActive.vue?vue&type=script&lang=js"
export * from "./LeadToActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports